<template>
    <el-form-item label="Edycja"
                  :error="errors"
                  :required="required">
        <el-select filterable
                   :value="value"
                   :clearable="clearable"
                   @change="$emit('input', $event)"
                   placeholder="Edycja">
            <el-option v-for="edition in $store.state.editions"
                       :key="edition.id"
                       :label="edition.year"
                       :value="edition.id">
            </el-option>
        </el-select>
    </el-form-item>
</template>
<script>
    export default {
        props: ['value', 'errors', 'required', 'clearable'],
        mounted () {
            this.$store.dispatch('fetchEditions')
        }
    }
</script>



// WEBPACK FOOTER //
// EditionInput.vue?46f73898